import { FC } from 'react';
import { useTableCellContext } from 'components/Table/TableCell/context';
import { useEllipsisTooltipForTableCells } from 'hooks/useEllipsisTooltipForTableCells';
import TableCellTextModal from './TableCellTextModal';
import { useTableModalContext } from 'components/Table/context';
import { Box, useTheme } from '@chakra-ui/react';

const TableCellText: FC = () => {
  const theme = useTheme();

  const cellContext = useTableCellContext();
  if (cellContext.cellType === 'text' || !cellContext.cellType) {
    const {
      title,
      borderRadius,
      cellTextHeight,
      cellTextMinHeight,
      alignItems,
      justifyContent,
      margin,
      fontFamily,
      fontSize,
      color,
      lineHeight,
      textAlign,
      textDecoration,
      fontWeight,
      useTwoLineEllipsis = title?.length && title?.length > 30,
      hoverEllipsisBackgroundColor,
      dataTestId,
      onClick,
      underlineOnHover
    } = cellContext;

    const { setTableModalContent, setIsTableModalOpen } =
      useTableModalContext();

    const [cellTextRef, overflowActive] = useEllipsisTooltipForTableCells();

    const handleCellClick = () => {
      if (useTwoLineEllipsis && overflowActive) {
        setTableModalContent(<TableCellTextModal fullText={title} />);
        setIsTableModalOpen(true);
      }
      if (onClick) {
        onClick();
      }
    };

    const useCursorPointer = (): boolean => {
      if (onClick) {
        return true;
      }
      if (useTwoLineEllipsis && overflowActive) {
        return true;
      }
      return false;
    };

    return (
      <Box
        display='flex'
        alignItems={alignItems || 'center'}
        justifyContent={justifyContent || 'flex-start'}
        height={cellTextHeight || 'max-content'}
        minHeight={cellTextMinHeight || 'max-content'}
        margin={margin || 0}
        borderRadius={borderRadius || 0}
        cursor={useCursorPointer() ? 'pointer' : 'default'}
        maxW={300}
        _hover={
          useCursorPointer()
            ? { backgroundColor: hoverEllipsisBackgroundColor || 'transparent' }
            : {}
        }
        onClick={handleCellClick}
        data-testid={dataTestId || 'cjtable-cell-text-id'}
      >
        <Box
          color={color || theme.colors.mediumGrey}
          fontFamily={fontFamily || theme.fonts.regular}
          fontSize={fontSize || '12px'}
          fontWeight={fontWeight || 'normal'}
          lineHeight={lineHeight || '14px'}
          textAlign={textAlign || 'center'}
          textDecoration={textDecoration || 'initial'}
          {...(useTwoLineEllipsis
            ? {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box'
              }
            : {})}
          sx={
            useTwoLineEllipsis
              ? {
                  WebkitBoxOrient: 'vertical',
                  WebkitLineClamp: '2'
                }
              : {}
          }
          _hover={
            underlineOnHover
              ? {
                  textDecoration: `underline ${
                    color || theme.colors.mediumGrey
                  }`
                }
              : {}
          }
          ref={cellTextRef}
          data-testid='cjtable-cell-text-text'
        >
          {title}
        </Box>
      </Box>
    );
  }
  return null;
};

export default TableCellText;
